import { createFileRoute } from '@tanstack/react-router';
import { trpc } from '@/lib/trpc';
import { UploadSignedCopyPage } from './-components/contracts/upload-signed-copy-page';

export const Route = createFileRoute('/ngos/contracts/$contractId/upload')({
	loader: ({ context, params }) => {
		context.queryClient.prefetchQuery(trpc.contract.paperUpload.queryOptions({ contractId: params.contractId }));
	},
	component: UploadSignedCopyRoute,
});

function UploadSignedCopyRoute() {
	const { contractId } = Route.useParams();

	return <UploadSignedCopyPage contractId={contractId} />;
}
